import { ICrudGenericFields } from 'models/CrudInterface'

export const providerAttributesGlobalUploadFieldsDropDown: Array<ICrudGenericFields> =
	[
		{
			id: 'rsoc',
			type: 'text',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 30,
			autoComplete: 'new-off',
			disabled: false,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'categoria',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'providerCategory',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'Orden',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'orderProviderAttr',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'codigo',
			type: 'text',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'tipo_resp',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'responsibleType',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'cod_prov',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'province',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'cod_postal',
			type: 'text',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: '',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'vendedor',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'sellers',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		},
		{
			id: 'transporte',
			type: 'combo',
			labelWidth: 'col-sm-3',
			width: 'col-sm-9',
			height: 'col-sm-12',
			default: null,
			maxChars: 10,
			autoComplete: 'new-off',
			disabled: false,
			comboData: 'couriers',
			dependsOn: {
				id: '',
				values: [
					{
						idValue: '',
						disabled: false
					}
				]
			}
		}
	]
